import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import PasswordInput from "./passwordInput";
import "./auth.css";
import { Dots } from "../Loader/loader";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const hasArmenian = (text) => /[Ա-֏]/.test(text || "");

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const email = params.get("email") || "";

  const [form, setForm] = useState({ password: "", password_confirmation: "" });
  const [errors, setErrors] = useState({});
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password_confirmation) {
      setErrors({ password_confirmation: ["Գաղտնաբառերը չեն համընկնում։"] });
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(
        `${API_BASE_URL}/api/auth/reset-password`,
        { token, email, ...form },
        { headers: { Accept: "application/json" } }
      );
      setDone(true);
    } catch (err) {
      if (err.response?.status === 422) {
        const data = err.response.data.errors || {};
        const emailError = data.email?.[0];
        setErrors({
          email: hasArmenian(emailError) ? [emailError] : undefined,
          password: data.password ? ["Գաղտնաբառը պետք է լինի առնվազն 8 նիշ։"] : undefined,
        });
      } else {
        setErrors({ email: ["Չհաջողվեց փոխել գաղտնաբառը։ Փորձեք կրկին։"] });
      }
    } finally {
      setSubmitting(false);
    }
  };

  const fieldError = (name) => errors[name] && <span className="auth-error">{errors[name][0]}</span>;

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Նոր գաղտնաբառ</h2>
        {done ? (
          <div className="auth-alert success">
            Գաղտնաբառը փոխվեց։ <Link to="/login">Մուտք գործել</Link>
          </div>
        ) : !token || !email ? (
          <div className="auth-alert">
            Հղումը սխալ է։ <Link to="/forgot-password">Պահանջել նորը</Link>
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            {errors.email && (
              <div className="auth-alert">
                {errors.email[0]} <Link to="/forgot-password">Պահանջել նոր հղում</Link>
              </div>
            )}
            <div className={`auth-field${errors.password ? " invalid" : ""}`}>
              <label htmlFor="password">Նոր գաղտնաբառ</label>
              <PasswordInput
                id="password"
                name="password"
                autoComplete="new-password"
                value={form.password}
                onChange={handleChange}
                required
              />
              {fieldError("password")}
            </div>
            <div className={`auth-field${errors.password_confirmation ? " invalid" : ""}`}>
              <label htmlFor="password_confirmation">Կրկնեք գաղտնաբառը</label>
              <PasswordInput
                id="password_confirmation"
                name="password_confirmation"
                autoComplete="new-password"
                value={form.password_confirmation}
                onChange={handleChange}
                required
              />
              {fieldError("password_confirmation")}
            </div>
            <button className="auth-btn" type="submit" disabled={submitting}>
              {submitting ? <Dots /> : "Պահպանել"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
